/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { PathType } from '../models/PathType';

export class Path {
  /**
  * Absolute path to the file or directory to restore.
  */
  'path': string;
  'pathType': PathType;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "path",
      "baseName": "path",
      "type": "string",
      "format": ""
    },
    {
      "name": "pathType",
      "baseName": "pathType",
      "type": "PathType",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return Path.attributeTypeMap;
  }

  public constructor() {
  }
}



